import Event from './lib/event';

let stateKey, eventKey, keys = {
	hidden: "visibilitychange",
	webkitHidden: "webkitvisibilitychange",
	mozHidden: "mozvisibilitychange",
	msHidden: "msvisibilitychange"
};

for (stateKey in keys) {
	if (stateKey in document) {
		eventKey = keys[stateKey];
		break;
	}
}

function tabVisibility(c) {
	if (c) return document.addEventListener(eventKey, c);
	return !document[stateKey];
}

let UserActivity = {
	visibility: true,
	focus: true,

	onUserActivityChanged: Event(),

	init(){
		tabVisibility(e => {
			this.updateUserStatus();
		});

		window.addEventListener('focus', e => { this.focus = true; this.updateUserStatus(); });
		window.addEventListener('blur', e => { this.focus = false; this.updateUserStatus(); });
	},

	isUserActive(){
		return this.visibility && this.focus;
	},

	updateUserStatus(){
		this.visibility = tabVisibility();
		this.onUserActivityChanged(this.isUserActive());
	},
};

export default UserActivity;
